import { IMPORTANT_CONTACT_LIST,ADD_IMPORTANT_CONTACT,UPDATE_IMPORTANT_CONTACT,REMOVE_IMPORTANT_CONTACT,
  RESET_IMPORT_LIST
  ,SET_IMPORT_CONTACT} from "../../@jumbo/constant/ActionTypes";
  
  const INIT_STATE = {
    contactList: [],
    // addUser:null,
    currentuser:null,
    currentDetails:null,
    editList:false

   
  };
  
  export default (state = INIT_STATE, action) => {
    switch (action.type) {
      case IMPORTANT_CONTACT_LIST: {
        return {
          ...state,
          contactList: action.payload,
        };
      }
      case ADD_IMPORTANT_CONTACT: {
          return {
            ...state,
            contactList: [action.payload, ...state.contactList],
        };
       }
       case RESET_IMPORT_LIST:{
        return {
          ...state,
          contactList: [],
      };
       }
       case  SET_IMPORT_CONTACT: {
        return {
          ...state,
          currentDetails:action.payload
      };
    }
      case UPDATE_IMPORTANT_CONTACT: {
        return {
          ...state,
          contactList: state.contactList.map(contactList => (contactList.id === action.payload._id ? action.payload : contactList)),
        };
      
     }
     case REMOVE_IMPORTANT_CONTACT: {
      return {
        ...state,
        contactList: state.contactList.filter(contactList => contactList._id !== action.payload),
      };
    }
    // case EDIT_LIST: {
      
    //   return { ...state, editList: true };
    // }
      default:
        return state;
    }
  };
  